import {Component, HostBinding, Input, OnInit, ViewChild, inject} from '@angular/core';
import {ClsConfig} from '../../../util/cls-config';
import { FilteringLogic, IgxStringFilteringOperand } from '@infragistics/igniteui-angular/core';
import { IGX_GRID_DIRECTIVES, IgxGridComponent, IgxGridModule } from '@infragistics/igniteui-angular/grids/grid';
import { IgxIconComponent } from '@infragistics/igniteui-angular/icon';
import {IgxExcelExporterService, IgxPdfExporterService, IgxGridCell} from '@infragistics/igniteui-angular/grids/core';
import {MasOpcionesGridComponent} from '../../util/controles/mas-opciones-grid/mas-opciones-grid.component';
import {FiltroGeneralModernoComponent} from '../../util/controles/filtro-general-moderno/filtro-general-moderno.component';
import {ClsObjCrudCatalogos} from '../../../clases-pu/02-catalogos/cls-obj-crud-catalogos';
import {ClsObjGenerico} from '../../../clases-pu/util/cls-obj-generico';
import {INeodataMenu} from '../../../core/models/interfaces/generico-interface';
import {AppPresupuestosService} from '../../../core/services/app-presupuestos.service';
import {EnumMasOpciones} from '../../../core/models/enum/enum-mas-opciones';
import {ClsUtil} from '../../../util/cls-util';
import {VtnGenericaComponent} from '../../util/ventanas/vtn-generica/vtn-generica.component';
import {TranslateModule} from '@ngx-translate/core';
import {TipoMensajesService} from "../../../core/services/tipo-mensajes.service";
import {SummaryPipeNeoPipe} from "../../../core/pipes/summary-pipe-neo.pipe";
import {ClsPrograma} from "../../../core/models/cls-programa";
import { CrearComponenteDinamicoService } from '../../../core/services/crear-componente-dinamico.service';

@Component({
  selector: 'app-programas-de-obras',
  templateUrl: './programas-de-obras.component.html',
  styleUrls: ['./programas-de-obras.component.scss'],
  imports: [
    IgxGridModule,
    IGX_GRID_DIRECTIVES,
    TranslateModule,
    FiltroGeneralModernoComponent,
    IgxIconComponent,
    MasOpcionesGridComponent,
    SummaryPipeNeoPipe,
  ]
})
export class ProgramasDeObrasComponent extends ClsConfig implements OnInit {
  private infPpto = inject(AppPresupuestosService);
  private tipoMsg = inject(TipoMensajesService);
  private excelExportService = inject(IgxExcelExporterService);
  private pdfExportService = inject(IgxPdfExporterService);
  private crearCompDinamico = inject(CrearComponenteDinamicoService);

  @ViewChild('gridProgramaObra', {read: IgxGridComponent, static: true})
  public gridProgramaObra: IgxGridComponent;
  @ViewChild('masOpcionesG', {read: MasOpcionesGridComponent, static: true})
  public masOpcionesG: MasOpcionesGridComponent;
  @ViewChild('filtroGeneral', {read: FiltroGeneralModernoComponent, static: true})
  public filtroGeneral: FiltroGeneralModernoComponent;

  @Input()
  public modoEdicion = true;

  // ajuste de texto
  @HostBinding('class') public themesClass = 'noAjustarTexto';
  public clicked = false;

  public errorAlCargar: boolean;
  public dataProgramas: ClsPrograma[] = [];
  public activarBotones = false;
  // mostrar actionStrip
  public showActionStrip = true;
  // clase catalogos
  public mObjCRUDCatalogos: ClsObjCrudCatalogos = new ClsObjCrudCatalogos();
  private mObjGenerico: ClsObjGenerico = new ClsObjGenerico();
  // menucontextual
  public verContextMenu = false;
  public contextmenuX = 0;
  public contextmenuY = 0;
  public cellMenuContextaul: IgxGridCell;
  public menus: INeodataMenu[] = [];
  public lengthMenu: number;

  // ConfigGridLayout
  public optionsGridLocal = {
    cellSelection: true,
    rowSelection: false,
    filtering: false,
    advancedFiltering: true,
    paging: true,
    sorting: false,
    groupBy: true,
    columns: true,
    expansion: true,
    rowPinning: false,
    columnSelection: true
  };
  public vtnGenerico: VtnGenericaComponent;

  constructor() {
    super();
  }

  ngOnInit() {
    this.gridProgramaObra.data = [];
  }

  public async cargarProgramas(idPpto?: bigint) {
    if (!ClsUtil.esNulo(this.infPpto.organizacion)) {
      try {
        this.tipoMsg.mostrarWaitDialog('MENSAJES.WAIT.GET_CATALOGOS');
        this.mObjCRUDCatalogos.dataCatalogo = [];
        this.dataProgramas = [];
        await this.mObjCRUDCatalogos.obtenerCatalogo(0, 'ConsultarProgramas2021', idPpto);
        this.mObjCRUDCatalogos.dataCatalogo.forEach((programa: ClsPrograma) => {
          const programa2: ClsPrograma = {
            IdPrograma: programa.IdPrograma,
            NoPrograma: programa.NoPrograma,
            Descripcion: programa.Descripcion,
            IdCalendario: programa.IdCalendario,
            Calendario: programa.Calendario,
            FechaInicio: programa.FechaInicio,
            FechaFinal: programa.FechaFinal,
            NoPeriodos: programa.NoPeriodos,
            Periodicidad: programa.Periodicidad,
            CapturarPorcentaje: programa.CapturarPorcentaje,
            Vigente: programa.Vigente,
            DiasCalendario: programa.DiasCalendario,
            DiasHabiles: programa.DiasHabiles,
            JsonDetallePrograma: programa.JsonDetallePrograma,
            JsonRelaciones: programa.JsonRelaciones,
            JsonProgSum: programa.JsonProgSum
          };
          this.dataProgramas.push(programa2);
        });
        this.gridProgramaObra.data = this.dataProgramas;
        this.errorAlCargar = false;
        this.tipoMsg.cerrarWaitDialog();
      } catch (e) {
        this.tipoMsg.cerrarWaitDialog();
        this.errorAlCargar = true;
        this.tipoMsg.mostrarMsg(e.message, 'error');
      }
    }
  }

  public clearInput() {
    this.filtroGeneral.input.value = '';
    this.gridProgramaObra.clearFilter();
  }

  public filterInput(filtro: string) {
    this.gridProgramaObra.filteringLogic = FilteringLogic.Or;
    this.gridProgramaObra.filterGlobal(filtro, IgxStringFilteringOperand.instance().condition('contains'));
  }

  public handleRowSelection() {
    this.gridProgramaObra.nativeElement.focus();
  }

  public async onSelectionDropDown(opcion: string) {
    try {
      switch (opcion) {
        case EnumMasOpciones.ExportarExcel:
          const sms = await ClsUtil.exportarDatos(this.gridProgramaObra, this.mObjGenerico.getTranslationsGetCatalogos('MENSAJES.GRALS.PROGRAMAS_DE_OBRA'), this.excelExportService).then(sms => { return sms });
          this.tipoMsg.mostrarToast(this.mObjGenerico.getTranslationsSmsExportar(sms, this.gridProgramaObra.selectedRows.length));
          break;
        case EnumMasOpciones.ExportarPDF:
          await ClsUtil.abrirVentanaPersonalizarPDF(
            this.gridProgramaObra,
            this.mObjGenerico.getTranslationsGetCatalogos('MENSAJES.GRALS.PROGRAMAS_DE_OBRA'),
            this.pdfExportService,
            this.crearCompDinamico,
            this.tipoMsg,
            this.mObjGenerico
          );
          break;
        case EnumMasOpciones.Actualizar:
          await this.cargarProgramas();
          break;
        case EnumMasOpciones.LimpiarFiltroColumnas:
          this.clearInput();
          break;
      }
    } catch (e) {
      this.tipoMsg.mostrarMsg(e.message, 'error');
    }
  }

  public registroSeleccionado() {
    const rowSeleccionados: bigint[] = this.gridProgramaObra.selectedRows;
    try {
      if (rowSeleccionados.length === 0) {
        throw new Error('MENSAJES.ALERT.SELECCIONAR_REGISTRO');
      }
      const rowData = this.gridProgramaObra.getRowData(rowSeleccionados[0]);
      this.gridProgramaObra.doubleClick.emit(rowData);
    } catch (e) {
      this.tipoMsg.mostrarMsg(e.message, 'error');
    }
  }
}
